import Swal from "sweetalert2";
import './ToastAddToBasket.scss';
import {useNavigate} from "react-router-dom";

function ToastAddToBasket({cart, updateCart, setProductAdd, productAdd}) {
    const navigate = useNavigate();
    const closeSwal = () => {
        Swal.close();
        setProductAdd(false);
    }

    document.addEventListener('click', function (event) {
        if (!productAdd) {
            return;
        }
        const popup = Swal.getPopup();
        if (popup && !popup.contains(event.target)) {
            // closeSwal();
            // pose problème uniquement quand je suis déconnecté de mon compte
        }
    });

    const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        color: "#000",
        showCloseButton: true,
        background: "#fff",
        willClose: closeSwal,
        customClass: {
            timerProgressBar: "background-color: #ffffff !important",
            popup: 'swal-full-height',
            closeButton: 'custom-close-button',
        },
        showClass: {
            popup: window.innerWidth <= 600 ? 'slideInMobile' : 'slideIn',
            backdrop: ''
        },
        hideClass: {
            popup: window.innerWidth <= 600 ? 'slideOutMobile' : 'slideOut',
            backdrop: ''
        },
    });
    Toast.fire({
        html: `
<h3 class="toast-cart-title">Mon panier</h3>
<div class="toast-cart-items-container">
        ${cart && cart.map((cartElement, index) => `
            <div class="toast-cart-item">
                <img src="${cartElement.cover}" alt="${cartElement.name}">
                <div class="toast-cart-item-info">
                    <p class="toast-item-name">${cartElement.name}</p>
                    <p class="toast-item-qty">Qté: ${cartElement.amount}</p>
                </div>
                <p class="toast-item-price">${cartElement.price.toFixed(2)} €</p>
            </div>
        `).join('')}
</div>
<div class="toast-btn-container">
    <button onclick="window.location.href = '/panier'">Voir mon panier</button>
</div>`,
    });
    return null;
}

export default ToastAddToBasket;